import React, { memo } from 'react';

const HiddenGems = ({ hiddenGems }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">💎 Hidden Gems & Local Secrets</h2>
      {hiddenGems.map((gem, idx) => (
        <div key={idx} className="bg-white/90 dark:bg-gray-800/90 backdrop-blur rounded-lg shadow-md p-4 border border-orange-100 dark:border-gray-700">
          <h3 className="font-semibold text-lg mb-2 dark:text-gray-100">{gem.name}</h3>
          <p className="text-gray-700 dark:text-gray-300 mb-1">{gem.description}</p>
          <p className="text-sm text-orange-600 dark:text-orange-400 italic">{gem.note}</p>
        </div>
      ))}
    </div>
  );
};

export default memo(HiddenGems);